export default "__VITE_ASSET__DZAkjFn3__"